import React, { Component } from "react";
import { Col } from "reactstrap";
import { PrevIcon, NextIcon } from "../Icon";

interface Props {
  limit: number | undefined;
  startCount: number | undefined;
  endCount: number | undefined;
  pageNumber: number | undefined;
  count: number | undefined;
  next: boolean | undefined;
  prev: boolean | undefined;
  textShow?: string | undefined;
  className?: string | undefined;
  updateState: (data: any) => void;
  fetchData: Function;
  history?: any;
  search_value?: string | null;
}

let pageNum = 0,
  urlLimit = 10;

class AkPagination extends Component<Props> {
  componentDidMount() {
    const { location: { search = "" } = {} } = window;

    if (search) {
      //if url params avilable then calling fetchData api.
      const params = new URLSearchParams(search);
      urlLimit = Number(params.get("limit")) || 10;
      pageNum = Number(params.get("page")) || 0;
      this.handleChange("url");
    }
  }

  handleUrlSync = (page: number, limit: number) => {
    const { history = {}, history: { location = {} } = {} } = this.props;

    history.push({
      ...location,
      search: "?page=" + page + "&limit=" + limit,
    });
  };

  handleChange = (page: any) => {
    let {
      limit = 10,
      startCount = 1,
      endCount = 10,
      pageNumber = 0,
      count = 0,
      history,
    } = this.props;

    endCount = count <= limit ? count : endCount;
    let endDiff = count - endCount;
    let offset = count % limit;

    switch (page) {
      case "next":
        pageNum = pageNumber + 1;
        let start =
          startCount + limit <= count ? startCount + limit : startCount;
        let end =
          endCount + limit < count
            ? endCount + (endDiff > limit ? limit : endDiff)
            : endCount + endDiff;
        // = 10 + 10 < 11 ?  10 + 1
        let n = end < count ? true : false;
        let p = start > 1 ? true : false;
        this.props.updateState({
          startCount: start,
          endCount: end,
          next: n,
          prev: p,
          pageNumber: pageNum,
        });
        history && this.handleUrlSync(pageNum, limit);
        break;
      case "prev":
        pageNum = pageNumber != 0 ? pageNumber - 1 : pageNumber;
        let startCnt = startCount - limit < 0 ? startCount : startCount - limit;
        let endCnt =
          endCount - limit < 0
            ? endCount
            : endDiff == 0
            ? endCount - offset
            : endCount - limit;
        let pre = startCnt > 1 ? true : false;
        let nex = endCnt < count ? true : false;
        this.props.updateState({
          startCount: startCnt,
          endCount: endCnt,
          prev: pre,
          next: nex,
          pageNumber: pageNum,
        });
        history && this.handleUrlSync(pageNum, limit);
        break;

      case "url":
        // setting initial start and end count based on page and limit from url params
        let startInit =
          pageNum * urlLimit + 1 <= count ? pageNum * urlLimit + 1 : count;
        let endInit =
          pageNum * urlLimit + urlLimit < count
            ? pageNum * urlLimit + urlLimit
            : count;

        let ni = endInit < count ? true : false;
        let pi = startInit > 1 ? true : false;
        this.props.updateState({
          startCount: startInit,
          endCount: endInit,
          next: ni,
          prev: pi,
          pageNumber: pageNum,
        });
        break;

      default:
        break;
    }

    if (this.props.search_value) {
      this.props.fetchData(pageNum * limit, limit, this.props.search_value);
    } else {
      this.props.fetchData(pageNum * limit, limit);
    }
  };

  render() {
    const {
      limit = 10,
      startCount = 1,
      endCount = 10,
      count = 0,
      next = true,
      prev = false,
      className = "",
      textShow = [],
    } = this.props;

    return (
      <>
        <Col sm={6} className={`pagination ${className}`}>
          {(textShow && textShow[0] ? textShow[0] : "") +
            startCount +
            (textShow && textShow[1] ? textShow[1] : " - ") +
            (count <= limit ? count : endCount) +
            " of " +
            count}

          <span
            className="pointer"
            onClick={() => (prev ? this.handleChange("prev") : null)}
          >
            <PrevIcon />
          </span>
          <span
            className="pointer"
            onClick={() =>
              next && count > limit ? this.handleChange("next") : null
            }
          >
            <NextIcon />
          </span>
        </Col>
      </>
    );
  }
}
export default AkPagination;
